import { FelhasznaloBeallitasokComponent } from './beallitasok/beallitasok.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NyilvantartoComponent } from './nyilvantarto/nyilvantarto.component';
import { FooldalComponent } from './fooldal/fooldal.component';
import { ValasztoComponent } from './valaszto/valaszto.component';
//import { OidcAuthGuard } from '@auth0/auth0-angular';
import { ProfilComponent } from './profil/profil.component';
import { SettingsComponent } from './settings/settings.component';
import { MunkatarsakComponent } from './munkatarsak/munkatarsak.component';
import { TtfComponent } from './ttf/ttf.component';
import {ChangelogComponent} from "./changelog/changelog.component";
import { JogszabalyfigyeloComponent } from "./jogszabalyfigyelo/jogszabalyfigyelo.component";
import { fejlesztoGuard } from "./jogszabalyfigyelo/fejleszto";
import {AuthGuard} from "./auth.guard";
import {FaliujsagComponent} from "./faliujsag/faliujsag.component";
import {EtkezesComponent} from "./etkezes/etkezes.component";
import {EtkezesComponent as ea} from "./admin/etkezes/etkezes.component";
import {LevelComponent} from "./level/level.component";
import {LicenseComponent} from "./license/license.component";
import {MessageComponent} from "./message/message.component";
import { OrarendComponent } from './orarend/orarend.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
//import { MenueditorComponent } from './admin/menueditor/menueditor.component';
import { FoglalasComponent } from './foglalas/foglalas.component';
import { UrlapComponent } from './urlap/urlap.component';
import { DokumentumaimComponent } from './dokumentumaim/dokumentumaim.component';
import { NaptarComponent } from './naptar/naptar.component';
//import { HomeComponent } from './admin/home/home.component';
import { ErtekezletComponent } from './ertekezlet/ertekezlet.component';
import { LandingComponent } from './landing/landing.component';
import { AllomanyComponent } from './admin/allomany/allomany.component';
import { AdminLayoutComponent } from './admin/admin-layout/admin-layout.component';
import { ImportallomanyComponent } from './admin/importallomany/importallomany.component';
import { ImporttanulokComponent } from './admin/importtanulok/importtanulok.component';
import { TanuloComponent } from './admin/tanulo/tanulo.component';
import { CertComponent } from './admin/cert/cert.component';
import { NavComponent } from './admin/nav/nav.component';
import { SzulokComponent } from './admin/szulok/szulok.component';
import { ImportascComponent } from './admin/importasc/importasc.component';
import { PenzugyLayoutComponent } from './penzugy/penzugy-layout/penzugy-layout.component';
import { IktatgatoLayoutComponent } from './iktatgato/iktatgato-layout/iktatgato-layout.component';
import { IktAttekintesComponent } from './iktatgato/attekintes/attekintes.component';
import { IktErkeztetesComponent } from './iktatgato/erkeztetes/erkeztetes.component';
import { IktIktatasComponent } from './iktatgato/iktatas/iktatas.component';
import { IktUgyiratokComponent } from './iktatgato/ugyiratok/ugyiratok.component';
import { IktUgyiratComponent } from './iktatgato/ugyirat/ugyirat.component';
import { IktIratComponent } from './iktatgato/irat/irat.component';
import { IktKonyvekComponent } from './iktatgato/konyvek/konyvek.component';
import { IktIrattarComponent } from './iktatgato/irattar/irattar.component';
import { IktPostakonyvComponent } from './iktatgato/postakonyv/postakonyv.component';
import { IktBeallitasokComponent } from './iktatgato/beallitasok/beallitasok.component';
import { IktSulinformComponent } from './iktatgato/sulinform/sulinform.component';
import { IktKeresesComponent } from './iktatgato/kereses/kereses.component';
import { IktRiportComponent } from './iktatgato/riport/riport.component';
import { IktPartnerekComponent } from './iktatgato/partnerek/partnerek.component';
import { IktFeladatokComponent } from './iktatgato/feladatok/feladatok.component';
import { IktPeldanyokComponent } from './iktatgato/peldanyok/peldanyok.component';
import { IktKuldesComponent } from './iktatgato/kuldes/kuldes.component';
import { IktBkszComponent } from './iktatgato/bksz/bksz.component';
import { IktKuldemenyekComponent } from './iktatgato/kuldemenyek/kuldemenyek.component';
import { IktKezbesitesComponent } from './iktatgato/kezbesites/kezbesites.component';
import { CaesarLayoutComponent } from './caesar/caesar-layout/caesar-layout.component';
import { UgyekComponent } from './caesar/ugyek/ugyek.component';
import { UgyComponent } from './caesar/ugy/ugy.component';
import { SzemelyekComponent } from './caesar/szemelyek/szemelyek.component';
import { UgytipusokComponent } from './caesar/ugytipusok/ugytipusok.component';
import { SablonokComponent } from './caesar/sablonok/sablonok.component';
import { BeallitasokComponent as CaesarBeallitasokComponent } from './caesar/beallitasok/beallitasok.component';
import { IktatoComponent } from './caesar/iktato/iktato.component';
import { TeendokComponent } from './caesar/teendok/teendok.component';
import { RiportokComponent } from './caesar/riportok/riportok.component';
import { LoginComponent } from './login/login.component';
import { NaploLayoutComponent } from './naplo/naplo-layout/naplo-layout.component';
import { NaploOldalGuard } from './naplo/naplo-oldal.guard';
import { FomenuComponent as NaploFomenuComponent } from './naplo/fomenu/fomenu.component';
import { NaplokComponent as NaploNaplokComponent } from './naplo/naplok/naplok.component';
import { EszkozLayoutComponent } from './eszkoz/eszkoz-layout/eszkoz-layout.component';
import { EszkozokComponent } from './eszkoz/eszkozok/eszkozok.component';
import { MegterulesComponent } from './eszkoz/megterules/megterules.component';
import { SzamlazoLayoutComponent } from './szamlazo/szamlazo-layout/szamlazo-layout.component';
import { SzamlazoKezdolapComponent } from './szamlazo/kezdolap/kezdolap.component';
import { SzamlakComponent } from './szamlazo/szamlak/szamlak.component';
import { VevokComponent } from './szamlazo/vevok/vevok.component';
import { TermekekComponent } from './szamlazo/termekek/termekek.component';
import { BeallitasokComponent } from './szamlazo/beallitasok/beallitasok.component';
import { KasszaComponent } from './szamlazo/kassza/kassza.component';
import { KintlevosegekComponent } from './szamlazo/kintlevosegek/kintlevosegek.component';
import { InventarioLayoutComponent } from './inventario/layout/layout.component';
import { GepjarmuLayoutComponent } from './gepjarmu/layout/layout.component';
import { GjKezdolapComponent } from './gepjarmu/kezdolap/kezdolap.component';
import { GjJarmuvekComponent } from './gepjarmu/jarmuvek/jarmuvek.component';
import { GjSoforokComponent } from './gepjarmu/soforok/soforok.component';
import { GjCimtarComponent } from './gepjarmu/cimtar/cimtar.component';
import { GjKoltsegekComponent } from './gepjarmu/koltsegek/koltsegek.component';
import { GjBeallitasokComponent } from './gepjarmu/beallitasok/beallitasok.component';
import { GjUtnyilvantartasComponent } from './gepjarmu/utnyilvantartas/utnyilvantartas.component';
import { GjUtGpsComponent } from './gepjarmu/ut-gps/ut-gps.component';
import { GjElszamolasComponent } from './gepjarmu/elszamolas/elszamolas.component';
import { GjKikuldetesComponent } from './gepjarmu/kikuldetes/kikuldetes.component';
import { GjCegautoadoComponent } from './gepjarmu/cegautoado/cegautoado.component';
import { ModulUgyfelekComponent } from './components/modul-ugyfelek/modul-ugyfelek.component';
import { UgyfelportalComponent } from './ugyfelportal/ugyfelportal.component';
import { TobbintezmenyComponent } from './tobbintezmeny/tobbintezmeny.component';
import { EszkozBeallitasokComponent } from './eszkoz/beallitasok/beallitasok.component';
import { InventarioKezdolapComponent } from './inventario/kezdolap/kezdolap.component';
import { CikkekComponent } from './inventario/cikkek/cikkek.component';
import { KeszletComponent } from './inventario/keszlet/keszlet.component';
import { MozgasokComponent } from './inventario/mozgasok/mozgasok.component';
import { LeltarComponent } from './inventario/leltar/leltar.component';
import { InventarioBeallitasokComponent } from './inventario/beallitasok/beallitasok.component';
import { InventarioErtekelesComponent } from './inventario/ertekeles/ertekeles.component';
import { EgyeztetesComponent as NaploEgyeztetesComponent } from './naplo/egyeztetes/egyeztetes.component';
import { UgyfelekComponent as NaploUgyfelekComponent } from './naplo/ugyfelek/ugyfelek.component';
import { KonyvelesComponent as NaploKonyvelesComponent } from './naplo/konyveles/konyveles.component';
import { NaplofokonyvComponent } from './naplo/naplofokonyv/naplofokonyv.component';
import { ListakComponent as NaploListakComponent } from './naplo/listak/listak.component';
import { TorzsekComponent as NaploTorzsekComponent } from './naplo/torzsek/torzsek.component';
import { TarhelyComponent as NaploTarhelyComponent } from './naplo/tarhely/tarhely.component';
import { FiokokComponent as NaploFiokokComponent } from './naplo/fiokok/fiokok.component';
import { EonkormanyzatComponent as NaploEonkormanyzatComponent } from './naplo/eonkormanyzat/eonkormanyzat.component';
import { DokumentumtarComponent as NaploDokumentumtarComponent } from './naplo/dokumentumtar/dokumentumtar.component';
import { NavComponent as NaploNavComponent } from './naplo/nav/nav.component';
import { AdoszamlaComponent as NaploAdoszamlaComponent } from './naplo/adoszamla/adoszamla.component';
import { UpoBevallasokComponent as NaploUpoBevallasokComponent } from './naplo/upo-bevallasok/upo-bevallasok.component';
import { EafaComponent as NaploEafaComponent } from './naplo/eafa/eafa.component';
import { MunkatervComponent as NaploMunkatervComponent } from './naplo/munkaterv/munkaterv.component';
import { KettosComponent as NaploKettosComponent } from './naplo/kettos/kettos.component';
import { BankComponent as NaploBankComponent } from './naplo/bank/bank.component';
import { ElsoBeallitasComponent as NaploElsoBeallitasComponent } from './naplo/elso-beallitas/elso-beallitas.component';
import { UzemszunetComponent as NaploUzemszunetComponent } from './naplo/uzemszunet/uzemszunet.component';
import { TarsashazComponent as NaploTarsashazComponent } from './naplo/tarsashaz/tarsashaz.component';
import { IngatlanComponent as NaploIngatlanComponent } from './naplo/ingatlan/ingatlan.component';
import { OpgComponent as NaploOpgComponent } from './naplo/opg/opg.component';
import { SzinkronComponent as NaploSzinkronComponent } from './naplo/szinkron/szinkron.component';
import { TanusitvanyComponent as NaploTanusitvanyComponent } from './naplo/tanusitvany/tanusitvany.component';
import { EmailElkapoComponent } from './naplo/email-elkapo/email-elkapo.component';
import { NavBevallasokComponent } from './nav-nyomtatvany/bevallasok/bevallasok.component';
import { NavKapcsolatComponent } from './nav-nyomtatvany/nav-kapcsolat/nav-kapcsolat.component';
import { NavKitoltoComponent } from './nav-nyomtatvany/kitolto/kitolto.component';
import { BerLayoutComponent } from './ber/ber-layout/ber-layout.component';
import { UgyfelekComponent as BerUgyfelekComponent } from './ber/ugyfelek/ugyfelek.component';
import { AlkalmazottakComponent as BerAlkalmazottakComponent } from './ber/alkalmazottak/alkalmazottak.component';
import { SzamfejtesComponent as BerSzamfejtesComponent } from './ber/szamfejtes/szamfejtes.component';
import { ListakComponent as BerListakComponent } from './ber/listak/listak.component';
import { AtalanyComponent as BerAtalanyComponent } from './ber/atalany/atalany.component';
import { BeallitasokComponent as BerBeallitasokComponent } from './ber/beallitasok/beallitasok.component';
import { BerFomenuComponent } from './ber/fomenu/fomenu.component';
import { BerosszesitoComponent as BerBerosszesitoComponent } from './ber/adatszolg/berosszesito.component';
import { NyomtatvanyokComponent as BerNyomtatvanyokComponent } from './ber/adatszolg/nyomtatvanyok.component';
import { Adatszolgaltatas08Component as BerAdatszolgaltatas08Component } from './ber/adatszolg/adatszolgaltatas-08.component';
import { BerfeladasComponent as BerBerfeladasComponent } from './ber/adatszolg/berfeladas.component';
import { BerTorzsekComponent } from './ber/torzsek/torzsek.component';
import { BerLetiltasComponent } from './ber/letiltas/letiltas.component';
import { EfoComponent as BerEfoComponent } from './ber/efo/efo.component';
import { CegtelefonComponent as BerCegtelefonComponent } from './ber/cegtelefon/cegtelefon.component';
import { ReprezentacioComponent as BerReprezentacioComponent } from './ber/reprezentacio/reprezentacio.component';
import { JuttatasokComponent as BerJuttatasokComponent } from './ber/juttatasok/juttatasok.component';
import { SzamlaComponent } from './penzugy/szamla/szamla.component';
import { EgyenlegComponent } from './penzugy/egyenleg/egyenleg.component';
import { TandijComponent } from './penzugy/tandij/tandij.component';
import { NormativaComponent } from './penzugy/normativa/normativa.component';
import { SzamlanewComponent } from './penzugy/szamlanew/szamlanew.component';
import { BizonylatSzerkesztoComponent } from './penzugy/ujbizonylat/bizonylat-szerkeszto.component';
import { ImportszulokComponent } from './admin/importszulok/importszulok.component';
import { ErtekesitComponent } from './penzugy/ertekesit/ertekesit.component';
import { PosComponent } from './admin/pos/pos.component';
import { mFooldalComponent } from './mediator/fooldal/fooldal.component';
import { mProfileComponent } from './mediator/profile/profile.component';
import { mCommunityComponent } from './mediator/community/community.component';
import { MediatorLayoutComponent } from './mediator/mediator-layout/mediator-layout.component';
import { mPostComponent } from './mediator/post/post.component';
import { Orarendv2Component } from './orarendv2/orarendv2.component';
import { AdougyLayoutComponent } from './adougy/penzugy-layout/penzugy-layout.component';
import { KonyvelesComponent } from './adougy/konyveles/konyveles.component';
import { AdofolyoszamlaComponent } from './adougy/adofolyoszamla/adofolyoszamla.component';
import { ErtekelesekComponent } from './ertekelesek/ertekelesek.component';
import { OidcAuthGuard } from './authnew.guard';
import { TktComponent } from './tkt/tkt.component';
import { bFooldalComponent } from './bfooldal/bfooldal.component';
import { bBankComponent } from './bbank/bbank.component';
import { bKontirComponent } from './bkontir/bkontir.component';
import { TorzsadatComponent } from './admin/torzsadat/torzsadat.component';
import { AdminNyomtatvanyComponent } from './admin/nyomtatvany/nyomtatvany.component';
import { NyomtatvanyComponent } from './nyomtatvany/nyomtatvany.component';
import { KretaOrarendComponent } from './kreta-orarend/kreta-orarend.component';
import { OsztalyfonokComponent } from './osztalyfonok/osztalyfonok.component';
import { SzuloiJegyekComponent } from './szuloi-jegyek/szuloi-jegyek.component';
import { FogadooraComponent } from './fogadoora/fogadoora.component';
import { TanuloiAdatlapComponent } from './tanuloi-adatlap/tanuloi-adatlap.component';
import { CsaladiBelepesComponent } from './csaladi-belepes/csaladi-belepes.component';
import { BerletComponent } from './berlet/berlet.component';
import { SzuloiOrarendComponent } from './szuloi-orarend/szuloi-orarend.component';
import { BeadandokComponent } from './beadandok/beadandok.component';
import { FeladataimComponent } from './beadandok/feladataim.component';
import { EtlapComponent } from './etlap/etlap.component';
import { WebshopAdminComponent } from './webshop-admin/webshop-admin.component';
import { WebshopCatalogAdminComponent } from './webshop-catalog-admin/webshop-catalog-admin.component';
import { AdminDokumentumokComponent } from './admin/dokumentumok/dokumentumok.component';
import { TanevvaltoComponent } from './admin/tanevvalto/tanevvalto.component';
import { DoksigeneratorComponent } from './admin/doksigenerator/doksigenerator.component';
import { BerComponent } from './admin/ber/ber.component';
import { IgazolasComponent } from './admin/igazolas/igazolas.component';
import { AdatbankComponent } from './admin/adatbank/adatbank.component';
import { AdminKezdolapComponent } from './admin/kezdolap/kezdolap.component';
import { AdminKerettantervSorrendComponent } from './admin/kerettanterv-sorrend/kerettanterv-sorrend.component';
import { CsoportBesorolasComponent } from './admin/csoport-besorolas/csoport-besorolas.component';
import { OsztalyBesorolasComponent } from './admin/osztaly-besorolas/osztaly-besorolas.component';
import { CsaladComponent } from './admin/csalad/csalad.component';
import { MacAllowlistComponent } from './admin/mac-allowlist/mac-allowlist.component';
import { AllomanyOsszevonasComponent } from './admin/allomany-osszevonas/allomany-osszevonas.component';
import { AdminTantargyOsszevonasComponent } from './admin/tantargy-osszevonas/tantargy-osszevonas.component';
import { AdminErtekelesTipusComponent } from './admin/ertekeles-tipus/ertekeles-tipus.component';
import { AdminFelmentesComponent } from './admin/felmentes/felmentes.component';
import { AdminFegyelmiComponent } from './admin/fegyelmi/fegyelmi.component';
import { AdminKretaCsoportComponent } from './admin/kreta-csoport/kreta-csoport.component';
import { AdminNaptarTipusComponent } from './admin/naptar-tipus/naptar-tipus.component';
import { AdminCsengoComponent } from './admin/csengo/csengo.component';
import { AdminFeljegyzesTipusComponent } from './admin/feljegyzes-tipus/feljegyzes-tipus.component';
import { AdminDigitalisMunkarendComponent } from './admin/digitalis-munkarend/digitalis-munkarend.component';
import { EntraParositasComponent } from './admin/entra-parositas/entra-parositas.component';
import { EszkozeimComponent } from './eszkozeim/eszkozeim.component';
import { UzenetekComponent } from './uzenetek/uzenetek.component';
import { KretaSajatComponent } from './kreta-sajat/kreta-sajat.component';
import { TanmenetComponent } from './tanmenet/tanmenet.component';
import { KesesekComponent } from './kesesek/kesesek.component';
import { HelyettesitesBejelentesComponent } from './helyettesites-bejelentes/helyettesites-bejelentes.component';
import { LaptopComponent } from './laptop/laptop.component';
import { AdminZaroertekelesComponent } from './admin/zaroertekeles/zaroertekeles.component';
import { AdminMicrosoftGraphComponent } from './admin/microsoft-graph/microsoft-graph.component';
import { AdminPushBeallitasComponent } from './admin/push-beallitas/push-beallitas.component';
import { AdminNaplozarasComponent } from './admin/naplozaras/naplozaras.component';
import { AdminMulasztasErtesitesComponent } from './admin/mulasztas-ertesites/mulasztas-ertesites.component';
import { AdminJegyEllenorzesComponent } from './admin/jegy-ellenorzes/jegy-ellenorzes.component';
import { AdminTanarJegyekComponent } from './admin/tanar-jegyek/tanar-jegyek.component';
import { AdminKonyveletlenOrakComponent } from './admin/konyveletlen-orak/konyveletlen-orak.component';
import { LemorzsolodasComponent } from './lemorzsolodas/lemorzsolodas.component';
import { AdminDapCsatlakozasComponent } from './admin/dap-csatlakozas/dap-csatlakozas.component';
import { AdminIdobelyegFelugyeletComponent } from './admin/idobelyeg-felugyelet/idobelyeg-felugyelet.component';
import { AdminKirstatComponent } from './admin/kirstat/kirstat.component';
import { AdminKirBejelentesComponent } from './admin/kir-bejelentes/kir-bejelentes.component';
import { AdminTanuloAtadoComponent } from './admin/tanulo-atado/tanulo-atado.component';
import { AdminKirImportVarazsloComponent } from './admin/kir-import-varazslo/kir-import-varazslo.component';
import { MinioBeallitasComponent } from './admin/minio-beallitas/minio-beallitas.component';
import { LicencComponent } from './admin/licenc/licenc.component';
import { KretaNaplozComponent } from './admin/kreta-naploz/kreta-naploz.component';
import { KretaEugyComponent } from './admin/kreta-eugy/kreta-eugy.component';
import { IkszSzinkronComponent } from './admin/iksz-szinkron/iksz-szinkron.component';
import { KretaFeljegyzesComponent } from './admin/kreta-feljegyzes/kreta-feljegyzes.component';
import { AdminKretaAtvitelComponent } from './admin/kreta-atvitel/kreta-atvitel.component';
import { AdminKretaOntesztComponent } from './admin/kreta-onteszt/kreta-onteszt.component';
import { IkszComponent } from './iksz/iksz.component';
import { SzuloiIkszComponent } from './szuloi-iksz/szuloi-iksz.component';
import { CheckoutSettingsComponent } from './admin/checkout-settings/checkout-settings.component';
import { StornoTomegesComponent } from './admin/storno-tomeges/storno-tomeges.component';
import { CashbookBeallitasComponent } from './admin/cashbook-beallitas/cashbook-beallitas.component';
import { SzamlatombComponent } from './admin/szamlatomb/szamlatomb.component';
import { IntezmenyBelepoComponent } from './intezmeny-belepo/intezmeny-belepo.component';
import { IdpRegisztracioComponent } from './admin/idp-regisztracio/idp-regisztracio.component';
import { AdminKapcsolatokComponent } from './admin/kapcsolatok/kapcsolatok.component';
import { AdminAdatexportComponent } from './admin/adatexport/adatexport.component';
import { AdminHozzaferesNaploComponent } from './admin/hozzaferes-naplo/hozzaferes-naplo.component';
import { AdminAdatmegorzesComponent } from './admin/adatmegorzes/adatmegorzes.component';
import { AdminAdatkezelesiSzabalyzatComponent } from './admin/adatkezelesi-szabalyzat/adatkezelesi-szabalyzat.component';
import { AdminBizonyitvanyMasodlatComponent } from './admin/bizonyitvany-masodlat/bizonyitvany-masodlat.component';
import { AdminJogosultsagComponent } from './admin/jogosultsag/jogosultsag.component';
import { AdminKinevezesComponent } from './admin/kinevezes/kinevezes.component';
import { AdminImpersonalasComponent } from './admin/impersonalas/impersonalas.component';
import { AdminTudasbazisComponent } from './admin/tudasbazis/tudasbazis.component';
import { AdminSmtpBeallitasComponent } from './admin/smtp-beallitas/smtp-beallitas.component';
import { AdminKonradBeallitasComponent } from './admin/konrad-beallitas/konrad-beallitas.component';
import { AdminHibajegyBeallitasComponent } from './admin/hibajegy-beallitas/hibajegy-beallitas.component';
import { HibajegyComponent } from './hibajegy/hibajegy.component';
import { AdatjavitasComponent } from './adatjavitas/adatjavitas.component';
import { AdminJogosultakComponent } from './admin/jogosultak/jogosultak.component';
import { AdminJogkorokComponent } from './admin/jogkorok/jogkorok.component';
import { AdminAtsorolasComponent } from './admin/atsorolas/atsorolas.component';
import { AdminBesorolasKetTablaComponent } from './admin/besorolas-ket-tabla/besorolas-ket-tabla.component';
import { AdminTanuloKilepesComponent } from './admin/tanulo-kilepes/tanulo-kilepes.component';
import { AdminImportCsoporttagsagComponent } from './admin/importcsoporttagsag/importcsoporttagsag.component';
import { AdminImportCsoportComponent } from './admin/importcsoport/importcsoport.component';
import { AdminImportOrarendComponent } from './admin/importorarend/importorarend.component';
import { AdminFrissitesComponent } from './admin/frissites/frissites.component';
import { FrissitesFolyamatbanComponent } from './frissites-folyamatban/frissites-folyamatban.component';
import { AdminKeycloakFiokokComponent } from './admin/keycloak-fiokok/keycloak-fiokok.component';
import { AdminMenuszerkesztoComponent } from './admin/menuszerkeszto/menuszerkeszto.component';
import { AlapertelmezettIntezmenyComponent } from './admin/alapertelmezett-intezmeny/alapertelmezett-intezmeny.component';
import { AdminModulTemaComponent } from './admin/modul-tema/modul-tema.component';
import { AdminEvKiuritesComponent } from './admin/ev-kiurites/ev-kiurites.component';
import { AdminFelhasznalokComponent } from './admin/felhasznalok/felhasznalok.component';
import { AkadalymentessegComponent } from './akadalymentesseg/akadalymentesseg.component';
import { AdatkezelesComponent } from './adatkezeles/adatkezeles.component';
import { OkiratEllenorzesComponent } from './okirat-ellenorzes/okirat-ellenorzes.component';


const routes: Routes = [
  /*  A „frissítés folyamatban" oldal ŐR NÉLKÜL érhető el: frissítés közben a
   *  bejelentkezés is akadozhat, és épp ez az az oldal, aminek akkor is működnie kell. */
  { path: 'frissites-folyamatban', component: FrissitesFolyamatbanComponent },
  /*  Kiállított okirat nyilvános ellenőrzése (Nkt. 57. § (6a)–(6b)) – ŐR NÉLKÜL: a bizonyítvány
   *  láblécében / QR-kódjában lévő címet bárki megnyithatja (backend/okirat-ellenorzes.js). */
  { path: 'ellenorzes', component: OkiratEllenorzesComponent },
  { path: 'ellenorzes/:azonosito', component: OkiratEllenorzesComponent },
  {
    // Helyi (standalone) bejelentkezés – guard nélkül, hogy elérhető legyen kilépve.
    path: 'login',
    component: LoginComponent,
  },
  {
    // Akadálymentesítési nyilatkozat (2018. évi LXXV. tv. 4. §) – NYILVÁNOS, őr nélkül:
    // bejelentkezés nélkül is el kell érni (a belépő oldal láblécéből és a menüből linkelve).
    path: 'akadalymentesseg',
    component: AkadalymentessegComponent,
  },
  {
    // Az intézmény adatkezelési szabályzata / tájékoztatója (Nkt. 43. § (1)) – NYILVÁNOS, őr nélkül, mint az
    // akadálymentesítési nyilatkozat: a belépő oldalról, a családi belépésből és a menüből linkelve.
    path: 'adatkezeles',
    component: AdatkezelesComponent,
  },
  {
    // Mobil pre-login intézmény/IdP-választó – guard NÉLKÜL (belépés előtt kell elérni).
    path: 'intezmeny-belepo',
    component: IntezmenyBelepoComponent,
  },
  {
    path: 'home',
    component: FooldalComponent,
    canActivate: [OidcAuthGuard],
  },
  // ÜGYFÉLPORTÁL: a könyvelt cég olvassa a saját könyvelését, bérét (backend/ugyfelportal.js).
  { path: 'ugyfelportal', component: UgyfelportalComponent, canActivate: [OidcAuthGuard] },
  // TÖBB INTÉZMÉNY, TÖBB RENDSZER (tobbintezmeny.js): megerősítés a másik rendszerben, rögzítés itthon.
  { path: 'tobbintezmeny/megerosit', component: TobbintezmenyComponent, canActivate: [OidcAuthGuard], data: { mod: 'megerosit' } },
  { path: 'tobbintezmeny/kesz', component: TobbintezmenyComponent, canActivate: [OidcAuthGuard], data: { mod: 'kesz' } },
  {
    // Semleges „átmeneti" landing modulváltás után (ne az előző modul oldala maradjon).
    path: 'valaszto',
    component: ValasztoComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'nyilvantarto',
    component: NyilvantartoComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'profil',
    component: ProfilComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'ttf',
    component: TtfComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'orarendv1',
    component: OrarendComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'orarend',
    component: Orarendv2Component,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'ertekelesek/:uzemmod',
    component: ErtekelesekComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'szuloi-jegyek',
    component: SzuloiJegyekComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    //  A felhasználó saját beállításai (téma modulonként, a menü és a fejléc színe).
    path: 'beallitasok',
    component: FelhasznaloBeallitasokComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'fogadoora',
    component: FogadooraComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    //  Tanulói adatlap: egy tanuló minden adata egy helyen, csak olvasásra (backend/tanuloi-adatlap.js).
    path: 'tanuloi-adatlap',
    component: TanuloiAdatlapComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // Közösségi szolgálat – a tanuló és a gondviselő nézete (haladás az 50 órához).
    path: 'kozossegi-szolgalat',
    component: SzuloiIkszComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // Családi belépések: a hiányzó családtag fiókja, önkiszolgálóan (szülő és tanuló).
    path: 'csaladi-belepes',
    component: CsaladiBelepesComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // Dolgozói bérlet-beadás és (bérügyi jogkörrel) elbírálás
    path: 'berlet',
    component: BerletComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'szuloi-orarend',
    component: SzuloiOrarendComponent,
    canActivate: [OidcAuthGuard],
  },
  // Digitális munkarend: beadandó feladatok – a tanár kiadja és visszajelez, a tanuló bead, a szülő olvas (backend/beadando.js).
  { path: 'beadandok', component: BeadandokComponent, canActivate: [OidcAuthGuard] },
  { path: 'feladataim', component: FeladataimComponent, canActivate: [OidcAuthGuard] },
  {
    path: 'webshop-admin/catalog',
    component: WebshopCatalogAdminComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'webshop-admin',
    component: WebshopAdminComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'nyomtatvany',
    component: NyomtatvanyComponent,
    canActivate: [OidcAuthGuard],
  },
  /*  A régi KRÉTA-kapu képernyője kivezetve: a mögötte lévő /api/kreta útvonal már
   *  nem áll fel, tehát csak hibát adna. Helyette az órarend-összevetés megy. */
  {
    path: 'kreta-diff',
    redirectTo: 'kreta-orarend',
    pathMatch: 'full',
  },
  {
    path: 'kreta-orarend',
    component: KretaOrarendComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'osztalyfonok',
    component: OsztalyfonokComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'munkatarsak',
    component: MunkatarsakComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'changelog',
    component: ChangelogComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // Fejlesztői, nem publikus: csak a kiszolgáló szerinti fejlesztőnek (backend/jogszabalyfigyelo.js).
    path: 'jogszabalyfigyelo',
    component: JogszabalyfigyeloComponent,
    canActivate: [OidcAuthGuard, fejlesztoGuard],
  },
  {
    path: 'faliujsag',
    component: FaliujsagComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'foglalas',
    component: FoglalasComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'etkezes',
    component: EtkezesComponent,
    canActivate: [OidcAuthGuard],
  },
  // Étlap – csak olvasható heti étlap (a tanulónak; backend/etkezes-etlap.js).
  { path: 'etlap', component: EtlapComponent, canActivate: [OidcAuthGuard] },
  {
    path: 'kerveny',
    component: UrlapComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'dokumentumaim',
    component: DokumentumaimComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // A tervező egyesítve a naptárba – régi link átirányítása.
    path: 'tanevrendje',
    redirectTo: 'naptar',
    pathMatch: 'full',
  },
  {
    path: 'level',
    component: LevelComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'naptar',
    component: NaptarComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'eszkozeim',
    component: EszkozeimComponent,
    canActivate: [OidcAuthGuard],
  },
  //  Fegyelmi eljárások – az osztályfőnök (saját osztály, olvasás) innen éri el; saját fejléccel.
  {
    path: 'fegyelmi',
    component: AdminFegyelmiComponent,
    canActivate: [OidcAuthGuard],
    data: { onallo: true },
  },
  {
    path: 'kesesek',
    component: KesesekComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'iksz',
    component: IkszComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'helyettesites-bejelentes',
    component: HelyettesitesBejelentesComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // Laptop-kölcsönzés: a bal menüben, a menüsor jogosultsága dönti el, ki látja.
    path: 'laptop',
    component: LaptopComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // Pedagógusi nézet: csak a saját osztály–tantárgy párjaihoz tölthet fel.
    path: 'tanmenet',
    component: TanmenetComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'kreta-sajat',
    component: KretaSajatComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'license',
    component: LicenseComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // A régi MessageComponent a repóban marad (nincs útvonala): az új, szálas
    // levelezés ugyanazon a /message útvonalon jön, hogy a meglévő menüsor működjön.
    path: 'message',
    component: UzenetekComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'uzenetek',
    component: UzenetekComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // Hibajelentés: lista, új bejelentés (/hibajegy/uj) és egy jegy (/hibajegy/:id) – egy komponens.
    path: 'hibajegy',
    component: HibajegyComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'hibajegy/:id',
    component: HibajegyComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // Adathiba jelzése: a kolléga jelzi (csoportváltás, hiányzó / rossz óra), a rendszer javítja.
    path: 'adatjavitas',
    component: AdatjavitasComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'ertekezlet',
    component: ErtekezletComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'tkt',
    component: TktComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'penzugy',
    canActivate: [OidcAuthGuard],
    component: PenzugyLayoutComponent,
    children: [
      { path: 'szamla', component: SzamlaComponent },
      { path: 'szamlanew', component: SzamlanewComponent },
      { path: 'egyenleg', component: EgyenlegComponent },
      { path: 'tandij', component: TandijComponent },
      { path: 'normativa', component: NormativaComponent },
      // Saját őr: a szülő-route (`penzugy`) canActivate-je nem fut le újra, amikor a
      // felhasználó a fülek közt vált – enélkül a gomb elrejtése önmagában megkerülhető.
      { path: 'ujbizonylat', component: BizonylatSzerkesztoComponent, canActivate: [OidcAuthGuard] },
      { path: 'ertekesit', component: ErtekesitComponent },
      { path: '', redirectTo: 'egyenleg', pathMatch: 'full' },
    ],
  },
  {
    // IKTATGATÓ – intézményi iratkezelés. NEM a CAESAR ügyvédi ügykezelő:
    // ott ügy → beadvány, itt iktatókönyv → ügyirat (főszám) → irat (alszám).
    path: 'iktatgato',
    canActivate: [OidcAuthGuard],
    component: IktatgatoLayoutComponent,
    children: [
      { path: 'attekintes', component: IktAttekintesComponent },
      { path: 'erkeztetes', component: IktErkeztetesComponent },
      { path: 'iktatas', component: IktIktatasComponent },
      { path: 'ugyiratok', component: IktUgyiratokComponent },
      { path: 'ugyirat/:id', component: IktUgyiratComponent },
      { path: 'irat/:id', component: IktIratComponent },
      { path: 'sulinform', component: IktSulinformComponent },
      { path: 'kereses', component: IktKeresesComponent },
      { path: 'riport', component: IktRiportComponent },
      { path: 'partnerek', component: IktPartnerekComponent },
      { path: 'feladatok', component: IktFeladatokComponent },
      { path: 'peldanyok', component: IktPeldanyokComponent },
      { path: 'kuldes', component: IktKuldesComponent },
      { path: 'bksz', component: IktBkszComponent },
      { path: 'kuldemenyek', component: IktKuldemenyekComponent },
      { path: 'kezbesites', component: IktKezbesitesComponent },
      { path: 'konyvek', component: IktKonyvekComponent },
      { path: 'irattar', component: IktIrattarComponent },
      { path: 'postakonyv', component: IktPostakonyvComponent },
      { path: 'beallitasok', component: IktBeallitasokComponent },
      { path: '', redirectTo: 'attekintes', pathMatch: 'full' },
    ],
  },
  {
    path: 'caesar',
    canActivate: [OidcAuthGuard],
    component: CaesarLayoutComponent,
    children: [
      { path: 'ugyek', component: UgyekComponent },
      { path: 'ugy/:id', component: UgyComponent },
      { path: 'teendok', component: TeendokComponent },
      { path: 'riportok', component: RiportokComponent },
      { path: 'szemelyek', component: SzemelyekComponent },
      { path: 'iktato', component: IktatoComponent },
      { path: 'sablonok', component: SablonokComponent },
      { path: 'ugytipusok', component: UgytipusokComponent },
      { path: 'beallitasok', component: CaesarBeallitasokComponent },
      { path: '', redirectTo: 'ugyek', pathMatch: 'full' },
    ],
  },
  // A FITNESS KILÉPETT A KERETRENDSZERBŐL.
  //
  // A felhasználói alkalmazás, a klinikusi munkatér és a korábbi
  // képernyők a `fitness-app/` alá költöztek: külön értékesített
  // program, saját szerverrel és saját felülettel. Az útvonalaik ezért
  // itt már NINCSENEK – a keretrendszer nem tölthet be olyan modult,
  // ami nem a része.
  //
  // A DEVCENTER IS VELÜK MENT. Kezdetben itt akartam hagyni, mert
  // „fejlesztői eszköz" – de a mérés mást mondott: a devcenter a
  // FITNESS admin- és validációs konzolja (23 munkaterület, a fitness
  // végpontkatalógusa, a fitness adatbázis-böngészője), és a conrad
  // súgómodulon át függ is tőle. Egy fejlesztői eszköz ahhoz a
  // termékhez tartozik, amit fejleszt.
  {
    path: 'naplo',
    canActivate: [OidcAuthGuard],
    // Az oldalak joga (jogkörszerkesztő) és a kötelező ügyfélválasztás – naplo-oldal.guard.ts.
    canActivateChild: [NaploOldalGuard],
    component: NaploLayoutComponent,
    children: [
      { path: 'fomenu', component: NaploFomenuComponent },
      { path: 'elso-beallitas', component: NaploElsoBeallitasComponent },
      { path: 'uzemszunet', component: NaploUzemszunetComponent },
      { path: 'naplok', component: NaploNaplokComponent },
      { path: 'egyeztetes', component: NaploEgyeztetesComponent },
      { path: 'ugyfelek', component: NaploUgyfelekComponent },
      { path: 'konyveles', component: NaploKonyvelesComponent },
      { path: 'kettos', component: NaploKettosComponent },
      { path: 'bank', component: NaploBankComponent, data: { nezet: 'szamlak' } },
      { path: 'kontir', component: NaploBankComponent, data: { nezet: 'kontir' } },
      { path: 'tarsashaz', component: NaploTarsashazComponent },
      { path: 'ingatlan', component: NaploIngatlanComponent },
      { path: 'opg', component: NaploOpgComponent },
      { path: 'szinkron', component: NaploSzinkronComponent },
      { path: 'tanusitvany', component: NaploTanusitvanyComponent },
      { path: 'email-elkapo', component: EmailElkapoComponent },
      { path: 'naplofokonyv', component: NaplofokonyvComponent },
      { path: 'listak', component: NaploListakComponent },
      { path: 'tarhely', component: NaploTarhelyComponent },
      { path: 'nav', component: NaploNavComponent },
      { path: 'adoszamla', component: NaploAdoszamlaComponent },
      { path: 'upo-bevallasok', component: NaploUpoBevallasokComponent },
      { path: 'eafa', component: NaploEafaComponent },
      { path: 'munkaterv', component: NaploMunkatervComponent },
      { path: 'fiokok', component: NaploFiokokComponent },
      { path: 'eonkormanyzat', component: NaploEonkormanyzatComponent },
      { path: 'dokumentumtar', component: NaploDokumentumtarComponent },
      { path: 'torzsek', component: NaploTorzsekComponent },
      // NAV-nyomtatványok (ÁNYK-szerű kitöltő) – a BÉR-rel közös motor.
      { path: 'bevallasok', component: NavBevallasokComponent, data: { modul: 'NAPLO' } },
      { path: 'bevallas/:id', component: NavKitoltoComponent, data: { modul: 'NAPLO' } },
      { path: 'nav-kapcsolat', component: NavKapcsolatComponent, data: { modul: 'NAPLO' } },
      // Ügyfél nélkül az oldalőr az ügyfélválasztóra visz; ügyféllel a főmenü a kezdőlap.
      { path: '', redirectTo: 'fomenu', pathMatch: 'full' },
    ],
  },
  // TÁRGYI ESZKÖZ (ESZKOZ) – önálló alrendszer, a NAPLO ügyfeleivel (közös adat).
  {
    path: 'eszkoz',
    canActivate: [OidcAuthGuard],
    component: EszkozLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'eszkozok' },
      { path: 'ugyfelek', component: ModulUgyfelekComponent, data: { alr: 'ESZKOZ' } },
      { path: 'eszkozok', component: EszkozokComponent, data: { ful: 'lista' } },
      { path: 'ecs', component: EszkozokComponent, data: { ful: 'ecs' } },
      { path: 'megterules', component: MegterulesComponent },
      { path: 'beallitasok', component: EszkozBeallitasokComponent },
    ],
  },
  // KÉSZLETKEZELÉS (INVENTARIO) – önálló alrendszer, a Számla és Kasszával közös cikktörzzsel.
  {
    path: 'inventario',
    canActivate: [OidcAuthGuard],
    component: InventarioLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'kezdolap' },
      { path: 'kezdolap', component: InventarioKezdolapComponent },
      { path: 'ugyfelek', component: ModulUgyfelekComponent, data: { alr: 'INVENTARIO' } },
      { path: 'cikkek', component: CikkekComponent },
      { path: 'keszlet', component: KeszletComponent },
      { path: 'mozgasok', component: MozgasokComponent },
      { path: 'leltar', component: LeltarComponent },
      { path: 'ertekeles', component: InventarioErtekelesComponent },
      { path: 'beallitasok', component: InventarioBeallitasokComponent },
    ],
  },
  // GÉPJÁRMŰ (GEPJARMU) – önálló alrendszer: járművek, útnyilvántartás, km-elszámolás, kiküldetés, költségek, cégautóadó.
  {
    path: 'gepjarmu',
    canActivate: [OidcAuthGuard],
    component: GepjarmuLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'kezdolap' },
      { path: 'ugyfelek', component: ModulUgyfelekComponent, data: { alr: 'GEPJARMU' } },
      { path: 'kezdolap', component: GjKezdolapComponent },
      { path: 'jarmuvek', component: GjJarmuvekComponent },
      { path: 'soforok', component: GjSoforokComponent },
      { path: 'cimtar', component: GjCimtarComponent },
      { path: 'koltsegek', component: GjKoltsegekComponent },
      { path: 'beallitasok', component: GjBeallitasokComponent },
      { path: 'utnyilvantartas', component: GjUtnyilvantartasComponent },
      { path: 'ut-gps', component: GjUtGpsComponent },
      { path: 'elszamolas', component: GjElszamolasComponent },
      { path: 'kikuldetes', component: GjKikuldetesComponent },
      { path: 'cegautoado', component: GjCegautoadoComponent },
      // A cégautóadó 2601-es bevallása a közös NAV-nyomtatványkitöltőben (a Bérből költözött, 2026-10-18).
      { path: 'bevallas/:id', component: NavKitoltoComponent, data: { modul: 'GEPJARMU' } },
    ],
  },
  // SZÁMLÁZÓ (SZAMLAZO) – önálló alrendszer a Könyvelés és a Bér mellett.
  {
    path: 'szamlazo',
    canActivate: [OidcAuthGuard],
    component: SzamlazoLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'kezdolap' },
      { path: 'kezdolap', component: SzamlazoKezdolapComponent },
      { path: 'ugyfelek', component: ModulUgyfelekComponent, data: { alr: 'SZAMLAZO' } },
      { path: 'szamlak', component: SzamlakComponent, data: { tipus: 'szamla' } },
      { path: 'dijbekerok', component: SzamlakComponent, data: { tipus: 'dijbekero' } },
      { path: 'kassza', component: KasszaComponent },
      { path: 'arajanlatok', component: SzamlakComponent, data: { tipus: 'arajanlat' } },
      { path: 'megrendelesek', component: SzamlakComponent, data: { tipus: 'megrendeles' } },
      { path: 'szallitolevelek', component: SzamlakComponent, data: { tipus: 'szallitolevel' } },
      { path: 'kintlevosegek', component: KintlevosegekComponent },
      { path: 'nyugtak', component: SzamlakComponent, data: { tipus: 'nyugta' } },
      { path: 'vevok', component: VevokComponent },
      { path: 'termekek', component: TermekekComponent },
      { path: 'beallitasok', component: BeallitasokComponent },
    ],
  },
  {
    path: 'ber',
    canActivate: [OidcAuthGuard],
    component: BerLayoutComponent,
    children: [
      { path: 'fomenu', component: BerFomenuComponent },
      { path: 'ugyfelek', component: BerUgyfelekComponent },
      { path: 'alkalmazottak', component: BerAlkalmazottakComponent },
      { path: 'szamfejtes', component: BerSzamfejtesComponent },
      { path: 'listak', component: BerListakComponent },
      { path: 'atalany', component: BerAtalanyComponent },
      { path: 'beallitasok', component: BerBeallitasokComponent },
      { path: 'bevallasok', component: NavBevallasokComponent, data: { modul: 'BER' } },
      { path: 'bevallas/:id', component: NavKitoltoComponent, data: { modul: 'BER' } },
      { path: 'nav-kapcsolat', component: NavKapcsolatComponent, data: { modul: 'BER' } },
      // Bér adatszolgáltatás (RLB főmenü): nyomtatványok, 08-as adatok, bérösszesítő időszakra, bérfeladás – ber/adatszolg/.
      { path: 'nyomtatvanyok', component: BerNyomtatvanyokComponent },
      { path: 'adatszolgaltatas-08', component: BerAdatszolgaltatas08Component },
      { path: 'berosszesito', component: BerBerosszesitoComponent },
      { path: 'berfeladas', component: BerBerfeladasComponent },
      // Cégautók: 2026-10-18-tól a Gépjármű modulban (gepjarmu/cegautoado) – a régi címek oda visznek.
      { path: 'cegauto-torzs', redirectTo: '/gepjarmu/jarmuvek' },
      { path: 'cegauto', redirectTo: '/gepjarmu/cegautoado' },
      { path: 'cegauto-lista', redirectTo: '/gepjarmu/cegautoado' },
      { path: 'cegauto-export', redirectTo: '/gepjarmu/cegautoado' },
      { path: 'letiltasok', component: BerLetiltasComponent },
      { path: 'jogcimek', component: BerTorzsekComponent, data: { nezet: 'jogcim' } },
      { path: 'munkaszamok', component: BerTorzsekComponent, data: { nezet: 'munkaszam' } },
      { path: 'nyugdijpenztarak', component: BerTorzsekComponent, data: { nezet: 'nyugdijpenztar' } },
      // Juttatások és EFO (RLB Számfejtés menü): EFO, cégtelefon, reprezentáció, béren kívüli juttatások – ber-juttatas.js.
      { path: 'efo', component: BerEfoComponent },
      { path: 'cegtelefon', component: BerCegtelefonComponent },
      { path: 'reprezentacio', component: BerReprezentacioComponent },
      { path: 'juttatasok', component: BerJuttatasokComponent },
      // Ügyféllel a főmenü a kezdőlap (a NAPLO-éhoz hasonlóan); ügyfél nélkül a főmenü az ügyfélválasztóra visz.
      { path: '', redirectTo: 'fomenu', pathMatch: 'full' },
    ],
  },
  {
    path: 'landing',
    component: LandingComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'admin',
    canActivate: [OidcAuthGuard],
    component: AdminLayoutComponent,
    children: [
      { path: 'allomany', component: AllomanyComponent },
      { path: 'etkezes', component: ea },
      { path: 'tanulo', component: TanuloComponent },
      { path: 'szulo', component: SzulokComponent },
      { path: 'cert', component: CertComponent },
      { path: 'nav', redirectTo: 'nav-adatkapcsolat', pathMatch: 'full' },
      { path: 'nav-adatkapcsolat', component: NavComponent },
      { path: 'checkout-fizetes', component: CheckoutSettingsComponent },
      { path: 'storno-tomeges', component: StornoTomegesComponent },
      { path: 'cashbook-beallitas', component: CashbookBeallitasComponent },
      { path: 'szamlatomb', component: SzamlatombComponent },
      { path: 'importasc', component: ImportascComponent },
      { path: 'importallomany', component: ImportallomanyComponent },
      { path: 'importtanulok', component: ImporttanulokComponent },
      { path: 'importtanmenet', component: TanmenetComponent },
      { path: 'importszulok', component: ImportszulokComponent },
      // KIR-import varázsló: tanulók, gondviselők, alkalmazottak egy helyen, előnézettel (backend/kir-import.js).
      { path: 'kir-import', component: AdminKirImportVarazsloComponent },
      { path: 'torzsadat', component: TorzsadatComponent },
      { path: 'nyomtatvany', component: AdminNyomtatvanyComponent },
      { path: 'dokumentumok', component: AdminDokumentumokComponent },
      { path: 'tanevvalto', component: TanevvaltoComponent },
      { path: 'doksigenerator', component: DoksigeneratorComponent },
      { path: 'ber', component: BerComponent },
      { path: 'igazolas', component: IgazolasComponent },
      { path: 'adatbank', redirectTo: '/adatbank', pathMatch: 'full' },
      { path: 'kerettanterv-sorrend', component: AdminKerettantervSorrendComponent },
      { path: 'zaroertekeles', component: AdminZaroertekelesComponent },
      { path: 'microsoft-graph', component: AdminMicrosoftGraphComponent },
      { path: 'push-beallitas', component: AdminPushBeallitasComponent },
      { path: 'naplozaras', component: AdminNaplozarasComponent },
      { path: 'mulasztas-ertesites', component: AdminMulasztasErtesitesComponent },
      { path: 'jegy-ellenorzes', component: AdminJegyEllenorzesComponent },
      { path: 'tanar-jegyek', component: AdminTanarJegyekComponent },
      // Könyveletlen órák: ki mit nem írt még be a naplóba (backend/munkaido-elszamolas.js › konyveletlen).
      { path: 'konyveletlen-orak', component: AdminKonyveletlenOrakComponent },
      { path: 'lemorzsolodas', component: LemorzsolodasComponent },
      { path: 'dap-csatlakozas', component: AdminDapCsatlakozasComponent },
      { path: 'idobelyeg-felugyelet', component: AdminIdobelyegFelugyeletComponent },
      { path: 'kirstat', component: AdminKirstatComponent },
      // KIR-bejelentések: a jogviszony-események 5 napos bejelentési határideje (backend/kir-bejelentes.js).
      { path: 'kir-bejelentes', component: AdminKirBejelentesComponent },
      // Iskolaváltás: átadó csomag (JSON + PDF) és átvétel (backend/tanulo-atado.js).
      { path: 'tanulo-atado', component: AdminTanuloAtadoComponent },
      { path: 'minio-beallitas', component: MinioBeallitasComponent },
      { path: 'licenc', component: LicencComponent },
      { path: 'kreta-naploz', component: KretaNaplozComponent },
      { path: 'kreta-eugy', component: KretaEugyComponent },
      { path: 'iksz-szinkron', component: IkszSzinkronComponent },
      { path: 'kreta-feljegyzes', component: KretaFeljegyzesComponent },
      // A KRÉTA-átvitel állapota adatkörönként + csak olvasó kapcsolat-önteszt (backend/kreta-atvitel.js).
      { path: 'kreta-atvitel', component: AdminKretaAtvitelComponent },
      // KRÉTA önteszt: az ütemezett feladatok futásai + funkciónkénti, csak olvasó önteszt (2026-11-02).
      { path: 'kreta-onteszt', component: AdminKretaOntesztComponent },
      { path: 'idp-regisztracio', component: IdpRegisztracioComponent },
      // Kapcsolatok: kapcsolati kód más intézménynek / rendszernek (backend/kapcsolat.js).
      { path: 'kapcsolatok', component: AdminKapcsolatokComponent },
      // Adatexport (JSON): kulcsos címek a KRÉTA-exportok tartalmával, BI-eszköznek (backend/adatexport.js).
      { path: 'adatexport', component: AdminAdatexportComponent },
      // Adatvédelem: hozzáférési napló (GDPR 32. cikk) és megőrzési kimutatás (Nkt. 41. § (10)–(10a)).
      { path: 'hozzaferes-naplo', component: AdminHozzaferesNaploComponent },
      { path: 'adatmegorzes', component: AdminAdatmegorzesComponent },
      // Az intézmény adatkezelési szabályzata / tájékoztatója (Nkt. 43. § (1)) – a nyilvános /adatkezeles oldalra.
      { path: 'adatkezelesi-szabalyzat', component: AdminAdatkezelesiSzabalyzatComponent },
      // Bizonyítványmásodlat (20/2012. EMMI r. 113. §): a tárolt adatokból, jelöléssel, iktatva, törzslap-bejegyzéssel.
      { path: 'bizonyitvany-masodlat', component: AdminBizonyitvanyMasodlatComponent },
      { path: 'alapertelmezett-intezmeny', component: AlapertelmezettIntezmenyComponent },
      // Modulonkénti téma (Klasszikus / Fókusz) – az intézmény összes modulja egy helyen.
      { path: 'modul-tema', component: AdminModulTemaComponent },
      { path: 'ev-kiurites', component: AdminEvKiuritesComponent },
      // Felhasználók és cégek: felvétel belépési fiókkal, cégkiosztás (backend/felhasznalok.js).
      { path: 'felhasznalok', component: AdminFelhasznalokComponent },
      { path: 'jogosultsag', component: AdminJogosultsagComponent, canActivate: [OidcAuthGuard] },
      { path: 'kinevezes', component: AdminKinevezesComponent, canActivate: [OidcAuthGuard] },
      { path: 'impersonalas', component: AdminImpersonalasComponent, canActivate: [OidcAuthGuard] },
      { path: 'tudasbazis', component: AdminTudasbazisComponent, canActivate: [OidcAuthGuard] },
      { path: 'smtp-beallitas', component: AdminSmtpBeallitasComponent, canActivate: [OidcAuthGuard] },
      { path: 'konrad-beallitas', component: AdminKonradBeallitasComponent, canActivate: [OidcAuthGuard] },
      { path: 'hibajegy-beallitas', component: AdminHibajegyBeallitasComponent, canActivate: [OidcAuthGuard] },
      { path: 'jogosultak', component: AdminJogosultakComponent, canActivate: [OidcAuthGuard] },
      { path: 'jogkorok', component: AdminJogkorokComponent, canActivate: [OidcAuthGuard] },
      { path: 'atsorolas', component: AdminAtsorolasComponent, canActivate: [OidcAuthGuard] },
      // Két táblás besorolás/átsorolás (KRÉTA-mintára) – osztályba és csoportba.
      { path: 'besorolas-ket-tabla', component: AdminBesorolasKetTablaComponent, canActivate: [OidcAuthGuard] },
      { path: 'tanulo-kilepes', component: AdminTanuloKilepesComponent, canActivate: [OidcAuthGuard] },
      { path: 'importcsoporttagsag', component: AdminImportCsoporttagsagComponent, canActivate: [OidcAuthGuard] },
      { path: 'importcsoport', component: AdminImportCsoportComponent, canActivate: [OidcAuthGuard] },
      { path: 'importorarend', component: AdminImportOrarendComponent, canActivate: [OidcAuthGuard] },
      { path: 'frissites', component: AdminFrissitesComponent, canActivate: [OidcAuthGuard] },
      { path: 'keycloak-fiokok', component: AdminKeycloakFiokokComponent, canActivate: [OidcAuthGuard] },
      { path: 'menuszerkeszto', component: AdminMenuszerkesztoComponent, canActivate: [OidcAuthGuard] },
      { path: 'osztaly-besorolas', component: OsztalyBesorolasComponent },
      { path: 'csoport-besorolas', component: CsoportBesorolasComponent },
      { path: 'csalad', component: CsaladComponent },
      { path: 'mac-allowlist', component: MacAllowlistComponent },
      { path: 'allomany-osszevonas', component: AllomanyOsszevonasComponent },
      { path: 'tantargy-osszevonas', component: AdminTantargyOsszevonasComponent },
      { path: 'ertekeles-tipus', component: AdminErtekelesTipusComponent },
      { path: 'felmentes', component: AdminFelmentesComponent },
      { path: 'fegyelmi', component: AdminFegyelmiComponent },
      { path: 'kreta-csoport', component: AdminKretaCsoportComponent },
      { path: 'naptar-tipus', component: AdminNaptarTipusComponent },
      { path: 'csengo', component: AdminCsengoComponent },
      { path: 'feljegyzes-tipus', component: AdminFeljegyzesTipusComponent },
      { path: 'digitalis-munkarend', component: AdminDigitalisMunkarendComponent },
      { path: 'entra-parositas', component: EntraParositasComponent },
      { path: 'pos', component: PosComponent },
      { path: 'kezdolap', component: AdminKezdolapComponent },
      { path: '', redirectTo: 'kezdolap', pathMatch: 'full' },
    ],
  },
  {
    path: 'konyveles',
    canActivate: [OidcAuthGuard],
    component: AdougyLayoutComponent,
    children: [
      { path: 'konyveles', component: KonyvelesComponent },
      { path: 'adofolyoszamla', component: AdofolyoszamlaComponent },
      { path: '', redirectTo: 'adofolyoszamla', pathMatch: 'full' },
    ],
  },
  {
    // Az Adatbank nem admin-funkció: pedagógus is használja, ezért saját, önálló
    // oldal – nem az admin felület gyerek-útvonala.
    path: 'adatbank',
    component: AdatbankComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    // A Tanügy menü „Tanmenet" pontja. Ugyanaz a képernyő, mint a /tanmenet:
    // a szerver dönti el, ki mihez tölthet fel.
    path: 'importtanmenet',
    component: TanmenetComponent,
    canActivate: [OidcAuthGuard],
  },
  {
    path: 'b',
    canActivate: [OidcAuthGuard],
    children: [
      { path: 'home', component: bFooldalComponent },
      { path: 'bank', component: bBankComponent },
      { path: 'kapocs/:adoszam', component: bBankComponent },
      { path: 'kontir/:adoszam', component: bKontirComponent },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
  {
    path: 'm',
    canActivate: [OidcAuthGuard],
    component: MediatorLayoutComponent,
    children: [
      { path: 'home', component: mFooldalComponent },
      { path: 'log', component: SzamlanewComponent },
      { path: 'community', component: mCommunityComponent },
      { path: 'post/:id', component: mPostComponent },
      { path: 'research', component: ErtekesitComponent },
      { path: 'admin', component: ErtekesitComponent },
      { path: 'profile', component: mProfileComponent },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
  /*{
            path: 'admin/allomany',
            component: AllomanyComponent,
            canActivate: [OidcAuthGuard],
          },*/
  /*{
    path: 'admin/menueditor',
    component: MenueditorComponent,
    canActivate: [OidcAuthGuard],
  },*/
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: 'print',
    loadChildren: () => import('./print/print.module').then( m => m.PrintPageModule)
  },
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'landing',
    pathMatch: 'full',
  },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
